var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.739,74.872c-5.845,0-15.142-0.619-26.566-1.648c-3.881-0.35-8.006-0.745-12.33-1.182 c-29.676-2.996-68.5-7.843-99.703-11.915L39.192,189.528l-2.452,18.715c0,0,66.497,9.228,131.433,14.967 c11.452,1.013,22.852,1.914,33.832,2.641c3.254,0.217,6.471,0.415,9.643,0.596c10.487,0.602,20.464,1.012,29.578,1.166 l7.134-111.073l2.412-37.517L194.739,74.872z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorado);
export default __webpack_public_path__ + "static/media/colorado.64b3a74f6de9c04c7b7ca0ea189db803.svg";
export { ForwardRef as ReactComponent };